module.exports = __webpack_public_path__ + "static/media/no_skills.6b8feae0.png";